import Aos from "aos";
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import "./index.scss";
function Owner() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  Aos.init({
    delay: 500,
    once: true,
  });
  return (
    <div>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ggilab.com/about/found-and-ceo"
        />
        <title>GGILab: Galaxy Gemological Institute's Founder & CEO</title>
        <meta
          name="description"
          content="Explore the story of Galaxy Gemological Institute, its passionate founder, and dedicated CEO. Learn how GGILab is shaping the gemology industry."
        />
      </Helmet>
      <div className="Owner">
        <div className="SectionOne">
          <div className="SectionTwo">
            <div className="left">
              <h1 data-aos="zoom-in">
The Visionary Behind GGI: Mr. Mohammad Ali (G.G.)</h1>
<h1>A Legacy in Gems
</h1>
              <p data-aos="flip-down" className="AboutIntro">
              Mr. Mohammad Ali (G.G.), the founder of 
                <span className="GGIFont">
                  {" "}
                  Galaxy Gemological Institute (GGI){" "}
                </span>{" "}
              comes from a distinguished lineage of jewelry retailers. This rich heritage, spanning over four generations, has instilled in him an unparalleled understanding of the gems and jewelry industry.

              </p>
              {/* <p data-aos="flip-up">
                Feeling the need of the industry Mohammad Ali established Galaxy
                Gemological Institute, where they provide diamond and gemstones
                testing in Karachi. He is also serving as:
              </p> */}
            </div>
            <div className="serving" data-aos="flip-up">
              {/* <h2 data-aos="flip-left">Also Serving :</h2>
              
              <h6 data-aos="fade-up-left">
                Independent Director on Board of Directors
              </h6> */}
              {/* <p data-aos="fade-right">
                Pakistan Industrial development Corporation (PIDC)
              </p>
              <h6 data-aos="fade-left">Senior Vice Chairman</h6>
              <p data-aos="fade-up">
                All Pakistan Commercial Exporters Association (APCEA)
              </p> */}
               <h2 data-aos="flip-left">Extensive Expertise
               </h2>
               <p data-aos="fade-up">
               Mr. Ali boasts over 20 years of experience in the industry, further enriched by prestigious positions at the Gemological Institute of America (GIA) as a staff gemologist and as a consultant for the Pakistan Gems and Jewelry Development Company (PGJDC). He brings a wealth of knowledge and a proven track record of excellence to GGI.
               </p> 
            </div>
            <div className="list">
            <h2 data-aos="flip-left">Driven by Innovation

               </h2>
               <p data-aos="fade-up">
               Fueled by a deep passion for the industry and a keen awareness of its needs, Mr. Ali established GGI in 2013. GGI pioneered diamond and gemstone testing in Karachi, setting a new standard for quality assurance in Pakistan's gem market.
               </p> 
              {/* <h2 data-aos="zoom-in-up">Qualifications</h2>

              <ul data-aos="zoom-in-down">
                <li data-aos="zoom-in-left">
                  <h4>MBA, Marketing</h4>
                  <p>Institute of Business Administration, Karachi, Pakistan</p>
                </li>
                <li data-aos="zoom-in-left">
                  <h4>B.Sc Managerial Finance</h4>
                  <p>University of Nevada Las Vegas, Las Vegas, USA</p>
                </li>
                <li data-aos="zoom-in-left">
                  <h4>Certificate of Director Education</h4>
                  <p>Pakistan Institute of Corporate Governance</p>
                </li>
                <li data-aos="zoom-in-left">
                  <h4>Applied Jewelry Arts</h4>
                  <p>Gemological Institute of America, Carlsbad, USA</p>
                </li>
                <li data-aos="zoom-in-left">
                  <h4>Pearls Graduate</h4>
                  <p>Gemological Institute of America, Carlsbad, USA</p>
                </li>
                <li data-aos="zoom-in-left">
                  <h4>Graduate Gemologist</h4>
                  <p>Gemological Institute of America, Carlsbad, USA</p>
                </li>
                <li data-aos="zoom-in-left">
                  <h4>Rough Diamond Grader</h4>
                  <p>International Gemological Institute, Mumbai, India</p>
                </li>
              </ul> */}
               <h2 data-aos="flip-left">Beyond GGI

</h2>
<p data-aos="fade-up">
Beyond his leadership at GGI, Mr. Ali is actively involved in shaping the industry landscape. Previously he served as an Independent Director on the Board of Directors of the Pakistan Industrial Development Corporation (PIDC) and as Senior Vice Chairman of the All Pakistan Commercial Exporters Association (APCEA).
</p> 
<h2 data-aos="flip-left">A Commitment to Excellence


</h2>
<p data-aos="fade-up">
Mr. Ali's impressive academic qualifications include an MBA in Marketing from the Institute of Business Administration, Karachi, a B.Sc. in Managerial Finance from the University of Nevada Las Vegas, and a Certificate of Director Education from the Pakistan Institute of Corporate Governance. Additionally, he holds certifications in Graduate Gemologist, Applied Jewelry Arts, Pearls Graduate, and Rough Diamond Grader from renowned institutions like the Gemological Institute of America (GIA) and the International Gemological Institute (IGI).


</p> 
<p data-aos="fade-up">
Mr. Ali's combination of extensive experience, academic achievements, and leadership roles makes him a true visionary in the world of gemstones. His dedication to excellence and commitment to elevating the industry standards are the cornerstones of GGI's success.
</p>


            </div>
          </div>
          <img
            alt="sl1_j3riop.webp"
            src={
              "https://res.cloudinary.com/ggi/image/upload/v1637903441/sl1_j3riop.webp"
            }
            className="right Image"
            data-aos="flip-left"
          />
        </div>
      </div>
    </div>
  );
}

export default Owner;
